import { AbstractBlock } from '../AbstractBlock';
import { ColorSettings } from '../setting/ColorSettings';
import { ShapeSettings } from '../setting/ShapeSettings';
import { CodeSetting } from '../setting/CodeSetting';
import { GlobalImport } from '../../utils/GlobalImport';
import { BlockType } from '../../@types/BlockType';
import { block_translation } from '../../lang/BlockTranslation';
const t = block_translation;
const Blockly = GlobalImport.getBlockly();

export class InitProcessBlock extends AbstractBlock {
  FUNCTION_NAME = 'FUNCTION_NAME';

  constructor(name: string) {
    super(name, t.to('初期化処理', 'init_process'));
  }
  defineBlock(block: BlockType): void {
    ColorSettings.setMoreColor(block);
    ShapeSettings.setSceneStartShape(block);

    // フィールド
    const functionName = new Blockly.FieldTextInput(t.to('ブロック名', 'block_name'));

    // 属性値の入力フィールド
    block
      .appendDummyInput()
      .appendField(t.to('初期処理', 'init_process'));

    ShapeSettings.addStatementInput(block);
  }

  codeGenerateCore(block: BlockType): string {
    const input = CodeSetting.getSubstatementCode(block);

    const str = `${input}`;

    return str;
  }
}
